import { render, staticRenderFns } from "./NewReleaseModal.vue?vue&type=template&id=0d3da588"
import script from "./NewReleaseModal.vue?vue&type=script&lang=js"
export * from "./NewReleaseModal.vue?vue&type=script&lang=js"
import style0 from "./NewReleaseModal.vue?vue&type=style&index=0&id=0d3da588&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports